import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminAiAssistant = lazy(() => import("@/pages/admin/AdminAiAssistant"));

export const Route = createFileRoute("/admin/ai-assistent/$threadId")({
  component: function ThreadPage() {
    const { threadId } = Route.useParams();
    return <AdminAiAssistant threadId={threadId} />;
  },
});
